// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__ckmh8","footer":"ModalInfo_footer__2bEAt"};